import { buildRouteSequence, type FlowSequenceContext } from './flow-sequence';
import type { SignupStep } from './steps';

export type StepGuardContext = FlowSequenceContext & {
  /** The funnel has an email once the entry step submitted successfully. */
  hasEmail: boolean;
};

/**
 * Funnel-integrity guards: a step renders only if the active
 * `buildRouteSequence` contains it. Without this, history back/forward could
 * land on a step the visitor's answers have since removed (e.g. `confirmation`
 * for a Google signup), leaving no defined next step. Flow state lives in memory, so a deep link or refresh
 * past the entry step has nothing to work with — every guard lands on
 * `index`. Returns the step to render: `step` itself when allowed, or the
 * bounce target.
 */
export function resolveGuardedStep(step: SignupStep, context: StepGuardContext): SignupStep {
  // Any step past entry needs the in-memory flow state seeded by the entry step's submit.
  if (step !== 'index' && !context.hasEmail) {
    return 'index';
  }

  if (!buildRouteSequence(context).includes(step)) {
    return 'index';
  }

  return step;
}
